import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import colors from 'theme/colors'

interface ILanguageSwitcherProps {
    locale: 'en' | 'fr'
    onLocaleChange: (locale: 'en' | 'fr') => void
}

const LanguageSwitcher: React.FC<ILanguageSwitcherProps> = ({ locale, onLocaleChange }) => {
    return (
        <ToggleButtonGroup
            value={locale}
            exclusive
            onChange={(_, newLocale) => newLocale && onLocaleChange(newLocale)}
            sx={{
                flexShrink: 0,
                backgroundColor: colors.platinum,
                borderRadius: '6px',
                padding: '1px',
                border: `1px solid ${colors.silver}`,
                '& .MuiToggleButtonGroup-grouped': {
                    border: 0,
                    borderRadius: '4px',
                    px: 1.5,
                    py: 0.5, 
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    textTransform: 'none',
                    '&.Mui-selected': {
                        backgroundColor: colors.white,
                        color: colors.primary,
                        boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
                        '&:hover': {
                            backgroundColor: colors.white,
                            color: colors.primary,
                        },
                    },
                    '&:not(.Mui-selected)': {
                        color: colors.grey,
                        backgroundColor: 'transparent',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            color: colors.primary,
                        },
                    },
                },
            }}
        >
            <ToggleButton
                value="en"
                data-testid="language-switcher-en"
                aria-label="English"
            >
                EN
            </ToggleButton>
            <ToggleButton
                value="fr"
                data-testid="language-switcher-fr"
                aria-label="Français"
            >
                FR
            </ToggleButton>
        </ToggleButtonGroup>
    )
}

export default LanguageSwitcher
